import { useQuery } from "@tanstack/react-query";
import { useAccountStore, useRevenueOverall } from "../../store";
import { getTotalErrorTransactionApi } from "../../services/record-transaction/get.total.error.transaction.api";

export const useGetTotalErrorApi = (storeCode: any) => {
  const { info } = useAccountStore();
  const { startDate, endDate, resultId } = useRevenueOverall();
  const { data, isLoading } = useQuery({
    queryKey: [
      "total-error-transaction",
      info?.id,
      endDate,
      startDate,
      storeCode,
      resultId,
    ],
    queryFn: () =>
      getTotalErrorTransactionApi(
        info?.role !== "ROLE_ADMIN" ? info?.id : undefined,
        startDate,
        endDate,
        storeCode,
        resultId
      ),
    enabled: false,
  });
  return {
    totalError: data,
    isLoading,
  };
};
